import { SlateElement, type SlateElementProps } from '@udecode/plate';

export function CodeLineElementStatic(props: SlateElementProps) {
  return <SlateElement {...props} />;
}
